import { useCenter } from "../../center";

/**
 * Whether a new booking opens its session at once, to be prepared: yes for a
 * training centre's mentor, who prepares every mentoring; a therapist's own
 * choice otherwise, starting from no.
 */
export function useOpenSessionByDefault(): boolean {
    const { center } = useCenter();
    return center?.type === "training";
}
